$(document).ready(function () {

	var resultTemplate = Hogan.compile('<div class="st-result {{tag}}"><h3 class="title"><a href="{{url}}" class="st-search-result-link">{{title}}</a></h3><div class="st-metadata"><div class="st-snippet">...{{{body}}}...</div></div></div>');
	var customRenderer = function(type, item) {
		var data = {
			title: item.title,
			url: item.url,
			body: item.highlight.body.substring(0, 280) || item.body.substring(0, 280),
			tag: (item.tag !== undefined) ? item.tag : 'page'
		};

		// Hide Sections
		$('.container.sections').hide();

		return resultTemplate.render(data);
	};

	var customPaginationForType = function (type, currentPage, totalPages) {
		var pages = '<div class="st-page">',
			previousPage, nextPage;

		if (currentPage != 1) {
			previousPage = currentPage - 1;
			pages = pages + '<a href="#" class="st-prev" data-hash="true" data-page="' + previousPage + '">Previous</a>';
		} else {
			pages = pages + '<span class="st-prev disabled">Previous</span>';
		}

		for (i = 1; i <= totalPages; i++) { 
			if (i === currentPage) {
				pages = pages + '<a href="#" class="st-jump current" data-hash="true" data-page="' + i + '">' + i + '</a>';
			} else {
				pages = pages + '<a href="#" class="st-jump" data-hash="true" data-page="' + i + '">' + i + '</a>';
			}
		}

		if (currentPage < totalPages) {
			nextPage = currentPage + 1;
			pages = pages + '<a href="#" class="st-next" data-hash="true" data-page="' + nextPage + '">Next</a>';
		} else {
			pages = pages + '<span class="st-next disabled">Next</span>';
		}
		pages += '</div>';
		return pages;
    };

	$('#st-search-input').swiftypeSearch({
		resultContainingElement: '#st-results-container',
		engineKey: 'ts6QfAri7C2sGx8mXAQ7',
		fetchFields: {'page': ['title', 'url', 'body', 'tag']},
		renderFunction: customRenderer,
		renderPaginationForType: customPaginationForType,
		perPage: 5
	});

	$('#st-results-container').on({
		mouseenter: function () {
			var result = $(this);
			result.prev().addClass('deselected');
		},
		mouseleave: function () {
			var result = $(this);
			result.prev().removeClass('deselected');
		}
	}, '.st-result');

	console.log('swiftype.js engine: ts6QfAri7C2sGx8mXAQ7');

});
